import { Tooltip } from 'bootstrap';
import React, { useEffect, useRef } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import AddressSearch from 'react-loqate';
import { Field } from '../../../types';

export interface HiddenProps {
    field: Field;
    inputRef: UseFormRegisterReturn;
}
function HiddenInput(props: HiddenProps) {
  const { field, inputRef } = props;
  return (
    <input id={field.formId} {...inputRef} key={field.id} type="hidden" className="form-control my-2" />

  );
}

export default HiddenInput;
